import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStartingPoint = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={410}
    height={139}
    fill="none"
    {...props}
  >
    <g filter="url(#StartingPoint_svg__a)" opacity={0.63}>
      <ellipse
        cx={112.5}
        cy={126}
        fill="#C5C6D6"
        fillOpacity={0.42}
        rx={46.5}
        ry={4.683}
      />
    </g>
    <path
      stroke="#C5C6D6"
      strokeDasharray="6.14 6.14"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M108 101.601S140 91 164 91s48.551 23.486 68 23.5S266.842 83 286 83s45 31.5 45 31.5"
    />
    <g filter="url(#StartingPoint_svg__b)">
      <path
        fill="url(#StartingPoint_svg__c)"
        d="M106.73 64.915c0-1.442.934-2.72 2.309-3.156a11.6 11.6 0 0 1 8.224.456l1.455.648a12.18 12.18 0 0 0 7.87.696 3.477 3.477 0 0 1 4.312 3.376v6.177a4.36 4.36 0 0 1-3.827 4.33l-.863.106a12.37 12.37 0 0 1-6.997-1.187l-1.326-.656a9.12 9.12 0 0 0-7.549-.24c-1.716.715-3.608-.546-3.608-2.405z"
      />
      <path
        fill="url(#StartingPoint_svg__d)"
        d="M107.829 99.568c.607 0 1.099-.492 1.099-1.1V79.102a1.099 1.099 0 0 0-2.197 0V98.47c0 .607.491 1.099 1.098 1.099"
      />
    </g>
    <circle cx={108} cy={101} r={4} fill="#C5C6D6" />
    <defs>
      <linearGradient
        id="StartingPoint_svg__c"
        x1={126.368}
        x2={96.149}
        y1={86.443}
        y2={86}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C5C6D6" />
        <stop offset={1} stopColor="#F6F6F9" />
      </linearGradient>
      <linearGradient
        id="StartingPoint_svg__d"
        x1={126.368}
        x2={96.149}
        y1={86.443}
        y2={86}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C5C6D6" />
        <stop offset={1} stopColor="#F6F6F9" />
      </linearGradient>
      <filter
        id="StartingPoint_svg__a"
        width={108.793}
        height={25.16}
        x={58.104}
        y={113.42}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_148_88619"
          stdDeviation={3.948}
        />
      </filter>
      <filter
        id="StartingPoint_svg__b"
        width={40.789}
        height={54.106}
        x={103.606}
        y={47.856}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={1.197} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_148_88619"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_148_88619"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SvgStartingPoint;
